export const FEED_MANAGER_INITIAL_STATE = {
  principal: "",
  securities: [],
  quote_feeds: [],
};

export const USE_MOCK_DATA = false;

export const API_KEYS_ALLOWED_IN_MOCK = [
  "ctd_2QJ3BtXoW67buc9k1En8Zxi4dvM6S32h5F0RytCV",
  "cts_sfKL7y4XI9W51PSiEsB7c432KY98VIR0pn6vGxfJ",
  "ctd_gn34ir8Klo9K3E54YCSV0zUor2XJd817ZuDx6Agk",
];

export const SECURITIES_MOCK = [
  ["MX0SGO0000N4", "UDI Bono 3.25% Nov-2043", "UDI NOV-43", "2043-11-01", "udi-bono"],
  ["MX0SGO0000M6", "UDI Bono 3.000% Dec-2026", "UDI DEC-26", "2026-12-01", "udi-bono"],
  ["MX0SGO0000K0", "UDI Bono 2.750% Nov-2031", "UDI NOV-31", "2031-11-01", "udi-bono"],
  ["MX0SGO0000I4", "UDI Bono 3.500% Nov-2023", "UDI NOV-23", "2023-11-01", "udi-bono"],
  ["MXMSGO000001", "M Bono 8.000% May-2035", "M MAY-35", "2035-05-01", "m-bono"],
  ["MX0MGO0001E4", "M Bono 8.0000% Jul-2053", "M JUL-53", "2053-07-01", "m-bono"],
  ["MX0MGO0001D6", "M Bono 7.500% May-2033", "M MAY-33", "2033-05-01", "m-bono"],
  ["MX0MGO0001C8", "M Bono 5.500% Mar-2027", "M MAR-27", "2027-03-01", "m-bono"],
  ["MX0MGO0001B0", "M Bono 5.000% Mar-2025", "M MAR-25", "2025-03-01", "m-bono"],
];

export const QUOTE_FEED_MOCK = [
  ["None", "none"],
  ["cicada", "413d1f78-2d29-4cf7-be5d-188543cd4d1a"],
  ["cicada-2", "e732c85b-3e55-4c36-a7fa-27511b9ea7ca"],
  ["cicada-3", "2e7d82e8-849d-49e3-bda2-8c23694868fd"],
];
